export default __webpack_public_path__ + "static/media/example-content4.221af7ab.jpg";